// extracted by mini-css-extract-plugin
export var card = "card-module--card--1vCiU";
export var title = "card-module--title--iSs4D";
export var link = "card-module--link--2jzkk";
export var content = "card-module--content--2VYgi";
export var labelItems = "card-module--labelItems--3IgVN";
export var fieldTitle = "card-module--fieldTitle--2EfmV";